const TimelineData = [
  {
    title: "Šprint 1. Broken Spell",
    date: "04-18.10.2021",
    place: "Bratislava FIIT",
    text: "V prvom šprinte sme sa úspešne odfotili. Na to sme nadviazali vytvorením webu. Celé to bol chaos tak sme si radšej spravili metodiky. Čas, ktorý ostal, sme minuli na analýzu, lebo sme zistili, že pýtať sa na to ako polievka chutí nie je správne. Všetko sme zvládli k spokojnosti a výkon bol taký, že Oki Mloky...",
    image: "https://www.cnet.com/a/img/VHMLZpX7mdHq5yF94Z_3sKpIVnE=/1200x675/2017/03/23/48e8c5e3-b87f-4549-bfbd-6db8140b5513/power-rangers-original.jpg"
  },
  {
    title: "Šprint 2. Code Busters",
    date: "18.10-01.11.2021",
    place: "Bratislava FIIT",
    text: "V tomto šprinte sme dokončili AML analýzu a už sme len čakali na dokonzultovanie. NFT sa nám darilo lepšie a už sa začalo aj implementovať. Trochu sme bojovali s BlockPayom, ale pomohli konzultácie s minuloročným tímom.",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrQ8cHnECaOmFRdwazhcvFOAGF7vXczw7CSg&usqp=CAU"
  },
  {
    title: "Šprint 3. Rock Solid",
    date: "01-15.11.2021",
    place: "Bratislava FIIT a Doma cez Internety",
    text: "Itváďok barátok, pracovať na tomto šprinte bol zážitok, asi ako nejesť mäso. Roboty bolo nad hlavu, ale veľa sa aj spravilo. PEP sa skonzultovalo, AML sme nahrabali dáta, vyhrali sme boj s BlockPayom, NFT postupuje raketovou rýchlosťou a ani s dokumentáciou sme sa neflákali.",
    image: "https://i.insider.com/536a52d9ecad042e1fb1a778?width=700"
  },
  {
    title: "Šprint 4. Whispering Voices",
    date: "15-29.11.2021",
    place: "Doma cez Internety",
    text: "Práca s cudzím kódom a tvorba ML modelov je niekedy také bullshit bingo. Ale my sme to zvládli. Okrem toho sme aj dokumentáciu odovzdali, frontend trošku upravili (až na footer...), NFT sa pohlo zas a znova ďalej a ešte aj PEPko máme naseedované. Život by bol super ak by nebol Logdan.",
    image: "https://www.chicagotribune.com/resizer/I4RCRTgtGxwir04DKUUC-nNFFOw=/800x530/top/arc-anglerfish-arc2-prod-tronc.s3.amazonaws.com/public/MJP7EW4X5RHFNONT7IYKICDMRI.jpg"
  },
  {
    title: "Šprint 5. Legendary Catastros",
    date: "29.11-13.12.2021",
    place: "Doma cez Internety",
    text: "Korelácia síce nie vždy implikuje kauzalitu, no blížiaci sa koniec semestra určite mal blahodárny účinok na našu náladu.Samko sa nechal došikanovať nginx-om pri nasadzovaní PEPka, AMLka a BlockPayu, ale jeho to vlastne baví. Marek nechcel byť pozadu, tak sa nechal došikanovať overleafom, ktorý zrazu neznáša prílohy. Všetci sme spoločnými silami dorazili dokumentáciu. Kikuško nám všetkým povedal akí sme super, tak sme ho aj my pochválili. Po poslednom posedení zimného semestra sme si zaželali Šťastné a Veselé a pobrali sme sa všetci masívne chillovať až do letného semestra. Koho by zaujímal rozdiel medzi čiernym a morbídnym humorom, musí si počkať do Februára.",
    image: "https://d26oc3sg82pgk3.cloudfront.net/files/media/edit/image/41140/article_full%401x.png"
  },
  {
    title: "Šprint 6. Fire Heart",
    date: "14.02-28.02.2022",
    place: "FIIT",
    text: "Leto začalo, ale motivácia nikde. Napriek tomu sme uviedli po pauze všetko do funkčného stavu. Dva kontrakty sa pocmukali a máme funkčné rentovanie NFT. AML sa začalo hýbať od modelu k implementácii a rozbehol sa už aj článoček na IIT SRC.",
    image: "https://www.denofgeek.com/wp-content/uploads/2020/11/Power-Rangers-Reboot-Universe.jpg"
  },
  {
    title: "Šprint 7. Stranger Within",
    date: "28.02-14.03.2022",
    place: "FIIT",
    text: "V tomto šprinte sme priniesli niečo nové pre vedeckú obec napísaním krásneho IIT SRC článočku. AML integrácia je v plnom prúde a napriek názorom všetkých hejterov sú NFT skoro hotové.",
    image: "http://themesong.info/wp-content/uploads/2021/11/Power-Rangers-Mystic-Force-Theme-Song.jpg"
  },
  {
    title: "Šprint 8. Petrified Xander",
    date: "14.03-28.03.2022",
    place: "FIIT",
    text: "Aj tie najlepšie tímy si zažijú krízu. My sme svoju prekonali a hrdo ideme ďalej. Slovami básnika: 'Horste, to ješte není vše!'",
    image: "https://i.kinja-img.com/gawker-media/image/upload/c_fill,f_auto,fl_progressive,g_center,h_675,pg_1,q_80,w_1200/7384f7342a0ca23306434d0dc319c6a6.png"
  },
  {
    title: "Šprint 9. The Gatekeeper",
    date: "28.03-11.04.2022",
    place: "FIIT",
    text: "Pozri šunes, blížime sa ku koncu tejto jazdy. AML-ko je už skoro hotové treba len dotestovať. Front end dostal face-lift, aj keď sa prvý pokus nestretol s pochopením. Dokumentácia sa začína tváriť finálne a už sa aj nejaké tie videjka natáčajú. Naše úspechy sme oslávili poctivím perníkom z Karlovky.",
    image: "https://sportshub.cbsistatic.com/i/2021/11/22/708f663d-b464-4481-8d67-6809cf14381f/power-rangers-universe.jpg"
  },
  {
    title: "Šprint 10. Scaredy Cat",
    date: "11.04-25.04.2022",
    place: "FIIT",
    text: "Plazmu poznáme síce iba krvnú, no náš progres to nezastavilo. Doladili sme nejaké drobnosti v AML, montujeme dokumentáciu, niečo sme potestovali. Mali sme EPICKÝ teambuilding...detaily sú prísne tajné.",
    image: "https://i0.wp.com/www.theilluminerdi.com/wp-content/uploads/2022/02/Power-Rangers-MMPR.jpeg"
  },
  {
    title: "Šprint 11. Dark Wish",
    date: "25.04-09.05.2022",
    place: "FIIT",
    text: "Marek...Marek...Marek...čo tu dnes pre nás máš? No mám tu koniec semestra a s ním aj koniec tímaku *sad noises*. Doladili sme posledné drobnosti, odprezentovali sme sa na IIT SRC, natočili sme krásne a perfektné video a dokončili našu stručnú (300 strán) dokumentáciu. Teraz už iba čakať na to ako dopadne TP CUP...teda vy čakajte...my to už vieme.",
    image: "https://i.pinimg.com/originals/4c/a9/f4/4ca9f4e20539ad992c6c59e5998a3c00.jpg"
  }
]

export default TimelineData;
